import { useQuery } from "@tanstack/react-query";

import { getAuthConfig } from "../services";

export const useAuthConfig = ({
    accessToken,
    accountId,
}: {
    accessToken?: string;
    accountId?: string;
}) => {
    const { data, isLoading } = useQuery({
        queryKey: ["auth-config", accessToken, accountId],
        queryFn: () => getAuthConfig({ accessToken, accountId }),
        enabled: !!accessToken && !!accountId,
    });

    return { authConfig: data, isLoading };
};
